import React, { useState } from "react";
import { Divider, Button, Modal } from "antd";
import Fact_Info from "./submission/fact_info";
import Fact_System from "./submission/fact_system";
import Fact_Users from "./submission/fact_users";
import { Row, Col } from "reactstrap";
import { useIndexedDB } from "react-indexed-db";
import useFetch from "../../Controllers/useFetch";
import { toast } from "react-toastify";
import ResultAlert from "./result_alert";
import { baseUrl } from "../../Controllers/rest_api_config";
import axios from "axios";
import { gql, useMutation } from "@apollo/client";
import { error, success } from "../../Controllers/toast";
import Cookies from "js-cookie"
import { useSelector } from "react-redux";

const CREATE_PLANT = gql`
  mutation CreatePlantInput(
    $fact_name: String!
    $fact_address: String!
    $fact_country: String!
    $fact_state: String!
    $fact_city: String!
    $fact_post_code: String!
    $fact_power_name: String!
    $fact_power_unit: String!
    $fact_tel: String!
    $fact_timezone: String!
    #
   
    $users: [usersArray]
    $devices: [deviceArray]
  ) {
    CreatePlant(
      plantInput: {
        fact_name: $fact_name
        fact_address: $fact_address
        fact_country: $fact_country
        fact_state: $fact_state
        fact_city: $fact_city
        fact_post_code: $fact_post_code
        fact_power_name: $fact_power_name
        fact_power_unit: $fact_power_unit
        fact_tel: $fact_tel
        fact_timezone: $fact_timezone
      }
     
      gatewayDevicesInput: { devices: $devices }
      plantUsers: { users: $users }
    ) {
      plant_id
      fact_name
    }
  }
`;

const user_id = Cookies.get("user_id")
const role = Cookies.get("user_role")
const firstname = window.localStorage.getItem("firstname")
const lastname = window.localStorage.getItem("lastname")
const email = window.localStorage.getItem("email")
const mobile = window.localStorage.getItem("mobile")
const user = [{ user_id, firstname, lastname, email, mobile, role }];

const Step4_submission = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [postData, setData] = useState([]);

  // console.log("input result is : ", props.checkData);
  const step1 = props.checkData[0];
  const step2 = props.checkData[1];
  // const step3 = props.checkData[2];
  const step4 = props.checkData[3];
  const { add } = useIndexedDB("ADDFACT");

  const [createPlant, { loading }] = useMutation(CREATE_PLANT, {
    onCompleted: (res) => {
      // console.log(res);
      if (res.CreatePlant.plant_id) {
        success(`${lang_choiced.pages.add_fact.rules.successAddPlant[0]} ${res.CreatePlant.fact_name} ${lang_choiced.pages.add_fact.rules.successAddPlant[1]}`)
      }
    },
    onError: (err) => {
      // console.log(err);
      error(lang_choiced.pages.add_fact.rules.errorAddPlant)
    },
  });

  return (
    <div>
      <Divider>{lang_choiced.pages.add_fact.step4.sections[0].title}</Divider>
      <div className="text-left">
        <Button
          danger
          onClick={() => {
            // console.log("i am here");
            props.countBack(4);
          }}
        >
          {" "}
          {lang_choiced.pages.add_fact.step4.sections[0].btnChange}
        </Button>
      </div>
      <Fact_Info inputData={step1} />
      <Divider>{lang_choiced.pages.add_fact.step4.sections[1].title}</Divider>
      <div className="text-left">
        <Button
          danger
          onClick={() => {
            props.countBack(3);
          }}
        >
          {" "}
          {lang_choiced.pages.add_fact.step4.sections[1].btnChange}
        </Button>
      </div>
      <Fact_System inputData={step2} />
      <Divider>{lang_choiced.pages.add_fact.step4.sections[2].title}</Divider>
      <div className="text-left">
        <Button
          danger
          onClick={() => {
            props.countBack(2);
          }}
        >
          {" "}
          {lang_choiced.pages.add_fact.step4.sections[2].btnChange}
        </Button>
      </div>
      <Fact_Users inputData={user} />
      <Row className="mt-4">
        <Col className="text-right">
          <Button
            onClick={() => {
              const resultData = [
                { addInfo: step1 },
                { addSystem: step2 },

                { rules: step4 },
              ];


              const systems = step2.map(
                ({ Gateway_id, serial_number, batch_number, model }) => { return { Gateway_id, serial_number, batch_number, model } }
              );
              setData(resultData);
              // console.log("result data is :", { ...step1 });
              createPlant({
                variables: {
                  ...step1,
                  devices: systems,
                  users: user,
                },
              });


            }}
            type="primary"
          >
            {lang_choiced.pages.add_fact.btnSend}
          </Button>
        </Col>
        <Col className="text-left">
          <Button
            onClick={() => {
              props.back(true);
            }}
            danger
          >
            {lang_choiced.pages.add_fact.btnBack}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Step4_submission;
